const POLYGON_TESTNET_CHAIN_ID = 80001;
const POLYGON_CHAIN_ID = 137;

const POLYGON_TESTNET_CHAIN_ID_HEX = "0x13881";
const POLYGON_CHAIN_ID_HEX = "0x89";

// Need to use double quotes for blockchain addresses for some reason
const NFT_SMART_CONTRACT_TESTNET_ADDRESS =
  "0x799689ae9c41415344Ef1A93a03f19f9e73be6F6";
const NFT_SMART_CONTRACT_ADDRESS = "0xF185cF406Ad74555A74770F4DE65D338a9E39407";

export {
  POLYGON_CHAIN_ID,
  POLYGON_TESTNET_CHAIN_ID,
  NFT_SMART_CONTRACT_ADDRESS,
  NFT_SMART_CONTRACT_TESTNET_ADDRESS,
  POLYGON_TESTNET_CHAIN_ID_HEX,
  POLYGON_CHAIN_ID_HEX,
};
